import { render, staticRenderFns } from "./ip-with-frequent-campaign-events.vue?vue&type=template&id=1d6d50b5&"
import script from "./ip-with-frequent-campaign-events.vue?vue&type=script&lang=ts&"
export * from "./ip-with-frequent-campaign-events.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports